$.fn.ToggleTableOfContents = function() {
  let self = this

  self.find('.table-of-contents__heading').click(function() {
    self.css('--max-height', self.find('.table-of-contents__list').outerHeight() + 'px')
    self.toggleClass('--closed')
  })

  return function() {
    return self
  }()
}
